import { consoleMsg, waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous, wireIssueTextAlert } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkIssue } from "../shared/templates";

const app = window.app;

export class Lights extends HTMLElement {
	async connectedCallback() {
		await waitForContent("lights");
		this.innerHTML = app.content.lights;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton6", "nextButton6"));

		// Render the OK / Issue questions component
		const questions = [
			["lights-main", "Low / high beams"],
			["lights-fog", "Fog lamps"],
			["lights-turn", "Turn signals"],
			["lights-brake", "Brake lights"],
			["lights-reverse", "Reverse lights"],
			["lights-license", "License plate lights"],
		];

		for (const [name, label] of questions) {
			this.querySelector(`#${name}-slot`).replaceWith(renderQuestionOkIssue(name, label, 6));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(6, pageElement);
		});
		this.addEventListener("ionViewDidEnter", async () => {
			// Wire up issue text alert handling
			wireIssueTextAlert("issueTextAlert6");

			const currentRoute = app.routes.lights;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
